<template>
  <div>
    <el-row>
      <el-col :xs='20' :sm='9' :md='7' :lg='6' :xl='4' v-loading="loadingAssignedApplications">
        <applications-lane
        :assignedApplications="assignedApplications"
        :assignedApps="assignedApps">
      </applications-lane>
      </el-col>
      <transition name="el-fade-in-linear">
      <el-col :xs='24' :sm='15' :md='17' :lg='18' :xl='16' v-loading="loadingWorkingApplication">
        <div class="grid-content bg-purple">
          <el-card class="box-card bg-purple" v-if="showWorkingApplication">
            <div slot="header" class="clearfix">
              <UserAppInfo></UserAppInfo>
            </div>
            <div class="text item">
              <el-tabs v-model="activeName" @tab-click="handleClick" :stretch=true :tab-position="tabPosition">
                <el-tab-pane label="Προσωπικά Στοιχεία" name="first">
                  <personal-details :personalDetails="workingApplication.personalDetails"></personal-details>
                </el-tab-pane>
                <el-tab-pane v-if="!isReappraisal && !isPostExam" label="Τίτλος Σπουδών" name="second">
                  <titles :application="workingApplication"></titles>
                </el-tab-pane>
                  <el-tab-pane label="Συνυποβολή Τίτλου" name="third"
                    v-if='workingApplication.degreeType === "bachelor" && workingApplication.consideration'>
                  <title-consideration :application="workingApplication"></title-consideration>
                </el-tab-pane>
               <el-tab-pane label="Επισυναπτόμενα" name="fourth">
                  <attached-documents
                    :userComment="workingApplication.userComment"
                    :attachedDocumentsTable="attachedDocumentsTable"
                    :appId="workingApplication.id"
                    :role="role"
                    :generalCommentProp="[]"
                    :neededDocuments="workingApplication.neededDocuments"
                    @changedAttachedDocs='changedAttachedDocsEvent'>
                  </attached-documents>
                </el-tab-pane>
               <el-tab-pane label="Ιστορικό" name="fifth" :lazy=true>
                  <history-line :applicationHistory="history"></history-line>
                </el-tab-pane>
                <el-tab-pane label="Αποτέλεσμα Επεξεργασίας" name="sixth">
                  <president-judgement
                    :academicAreas="academicAreas"
                    :specialProponents="specialProponents"
                    :finalDecisions="presidentDecisions"
                    :vicePresidentsA="vicePresidentsA"
                    :vicePresidentsB="vicePresidentsB"
                    :isReappraisal="isReappraisal"
                    :isPostExam="isPostExam"
                    :isSecondReappraisal="isSecondReappraisal">
                  </president-judgement>
                </el-tab-pane>
                <el-tab-pane label="Σχετική αίτηση" name="seventh" v-if="isReappraisal || isPostExam">
                  <relevant-app :relevantApp="workingApplication.relevantApplication"></relevant-app>
              </el-tab-pane>
               <el-tab-pane label="Αρχική επανεξέταση" name="eighth" v-if="isSecondReappraisal">
                  <first-reappraisal :relevantReappraisalApplication="workingApplication.relevantReappraisalApplication"
                   :relevantReappraisalAppl="workingApplication.relevantReappraisalAppl"></first-reappraisal>
              </el-tab-pane>
              </el-tabs>

            </div>
          </el-card>
        </div>
        <application-search v-show="searchVisible"></application-search>
        <search-uni v-show="searchUniVisible"></search-uni>
        <consultants-list v-show="consultantsListVisible"></consultants-list>
        <phd-registration v-show="phdRegistrationVisible"></phd-registration>
      </el-col>
    </transition>
    </el-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PresidentMenu from './roleSpecific/PresidentMenu'
import PersonalDetails from './common/PersonalDetails'
import Titles from './common/Titles'
import TitleConsideration from './common/TitleConsideration'
import AttachedDocuments from './common/AttachedDocuments'
import HistoryLine from './common/HistoryLine'
import ApplicationSearch from '@/components/common/ApplicationSearch'
import PrecheckerJudgment from './roleSpecific/PrecheckerJudgment'
import UserAppInfo from './common/UserAppInfo'
import axios from 'axios'
import sharedMethods from './common/sharedMethods.js'
import SearchUni from '@/components/common/SearchUni'
import ConsultantsList from '@/components/common/ConsultantsList'
import PhdRegistration from '@/components/common/PhdRegistration'
import ApplicationsLane from './common/ApplicationsLane'
import PresidentJudgement from './roleSpecific/PresidentJudgement'
import RelevantApp from './common/RelevantApp'
import FirstReappraisal from './common/FirstReappraisal'

export default {
  name: 'President',
  components: {
    ApplicationsLane,
    PresidentMenu,
    PersonalDetails,
    Titles,
    TitleConsideration,
    AttachedDocuments,
    HistoryLine,
    ApplicationSearch,
    PrecheckerJudgment,
    PresidentJudgement,
    UserAppInfo,
    SearchUni,
    ConsultantsList,
    PhdRegistration,
    RelevantApp,
    FirstReappraisal
  },
  mixins: [sharedMethods],
  mounted () {
    this.$store.dispatch('LOAD_PRESIDENT_DECISIONS')
    axios.get(`${this.BASE_URL}/roles/2`)
      .then((response) => {
        this.specialProponents = response.data.data
      }, (err) => {
        this.backendError(err)
        this.notifyUser(`Δεν φορτώθηκε η λίστα των Ειδικών Εισηγητών.`)
      })
    axios.get(`${this.BASE_URL}/roles/6`)
      .then((response) => {
        this.vicePresidentsA = response.data.data
      }, (err) => {
        this.backendError(err)
        this.notifyUser(`Δεν φορτώθηκε το όνομα του Αντιπροέδρου Ά.`)
      })
    axios.get(`${this.BASE_URL}/roles/7`)
      .then((response) => {
        this.vicePresidentsB = response.data.data
      }, (err) => {
        this.backendError(err)
        this.notifyUser(`Δεν φορτώθηκε το όνομα του Αντιπροέδρου ΄Β.`)
      })
    this.$store.dispatch('LOAD_ACADEMIC_AREAS')
  },
  data () {
    return {
      // assignedApps: {
      //   presidentW_Prechecker: [{ id: '1', surname: '', createdAt: '', degreeType: '' }],
      //   viewerW_Proponent: [{ id: '2', surname: '', createdAt: '', degreeType: '' }],
      //   presidentW_Consultant: [{ id: '3', surname: '', createdAt: '', degreeType: '' }],
      //   // viewerW_Board: [{ id: '4', surname: '', createdAt: '', degreeType: '' }],
      //   // viewerW_Vice: [{ id: '4', surname: '', createdAt: '', degreeType: '' }],
      //   presidentW_Viewer: [{ id: '4', surname: '', createdAt: '', degreeType: '' }],
      //   presidentW_PrintDecision: [{ id: '5', surname: '', createdAt: '', degreeType: '' }]
      // },
      assignedApps: {
        presidentW_Prechecker: [{ id: '1', surname: '', createdAt: '', degreeType: '' }],
        // viewerW_Proponent: [{ id: '2', surname: '', createdAt: '', degreeType: '' }],
        presidentW_Consultant: [{ id: '2', surname: '', createdAt: '', degreeType: '' }],
        presidentW_Viewer: [{ id: '3', surname: '', createdAt: '', degreeType: '' }],
        // presidentW_AcademicDirector_fromProponent: [{ id: '4', surname: '', createdAt: '', degreeType: '' }],
        presidentW_AcademicDirector: [{ id: '4', surname: '', createdAt: '', degreeType: '' }],
        presidentW_AcademicDirector_Reappraisal: [{ id: '5', surname: '', createdAt: '', degreeType: '' }],
        presidentW_ReappraisalBoard: [{ id: '6', surname: '', createdAt: '', degreeType: '' }],
        presidentW_PrintDecision: [{ id: '7', surname: '', createdAt: '', degreeType: '' }]
      },
      specialProponents: [],
      vicePresidentsA: [],
      vicePresidentsB: [],
      activeName: 'sixth',
      role: 'president',
      tabPosition: 'top'
    }
  },
  methods: {
    handleClick (tab, event) {
    },
    notifyUser (msg) {
      this.$notify.error({
        title: 'Σφάλμα',
        message: msg
      })
    },
    changedAttachedDocsEvent (docs) {
      let docComments = ''
      docs.forEach(doc => {
        if (doc.precheckerComment) {
          // Todo: this comment must be in English according to language
          docComments +=
          `<div><b>Τύπος</b>: ${doc.type}, <b>Κατάσταση</b>: ${doc.precheckerChecked ? 'Αποδεκτό' : 'Με εκκρεμότητα'}, <b>Σχόλιο</b>: ${doc.precheckerComment}</div>`
        }
      })
      this.judgementDocs = docComments
    }
  },
  computed: {
    finalDecisions () {
      return this.presidentDecisions
    },
    attachedDocumentsTable () {
      return this.workingApplication.attachedDocuments.slice(0).map(doc =>
        ({name: doc.name,
          type: doc.type,
          date: doc.date,
          applicantComment: doc.applicantComment,
          precheckerChecked: doc.precheckerChecked,
          precheckerComment: doc.precheckerComment,
          id: doc.id
        })
      )
    },
    isReappraisal () {
      return this.workingApplication.applicationType === 'reappraisal'
    },
    isPostExam () {
      return this.workingApplication.applicationType === 'compensatory'
    },
    isSecondReappraisal () {
      return this.workingApplication.reappraisalSecondDegree
    },
    // validatedFinalDecisions () {
    //   if (this.workingApplication.degreeType === 'bachelor') {
    //     return this.finalDecisions.filter(decision => decision.id <= 4)
    //   } else if (this.workingApplication.degreeType === 'master') {
    //     return this.finalDecisions.filter(decision => decision.id === 4 || decision.id === 6)
    //   } else if (this.workingApplication.degreeType === 'phd') {
    //     return this.finalDecisions.filter(decision => decision.id === 4 || decision.id === 5)
    //   } else {
    //     return this.finalDecisions
    //   }
    // },
    ...mapState([
      'activeLane',
      'searchVisible',
      'searchUniVisible',
      'consultantsListVisible',
      'phdRegistrationVisible',
      'internalUsers',
      'assignedApplications',
      'assignedProponentApplications',
      'assignedBoardApplications',
      'assignedViceApplications',
      'assignedPrintApplications',
      'loadingAssignedApplications',
      'workingApplication',
      'loadingWorkingApplication',
      'showWorkingApplication',
      'presidentDecisions',
      'BASE_URL',
      'academicAreas',
      'history'
    ])
  },
  watch: {
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/President.vue